



























import { computed, defineComponent, getCurrentInstance, onMounted, nextTick, ref, watch } from '@vue/composition-api';
import WelcomeHome from '@/renderer/views/desktop/FileManagement/Workbench/components/Welcome/components/Home.vue';
import WelcomeStep from '@/renderer/views/desktop/FileManagement/Workbench/components/Welcome/components/Step/index.vue';
import sidebarGuideHandler from '@/renderer/views/desktop/BaseSidebar/SidebarGuideHandler';
import { startGuideSteps } from '@/renderer/scripts/utils/GuideHelper';
import ipc from '@/renderer/scripts/utils/ipc';
import smh from '@/renderer/scripts/smh';
import user from '@/renderer/scripts/utils/user';
import { RoleMap } from '@/renderer/scripts/utils/ConstantConfig';
export default defineComponent({
  name: 'WelcomeDialog',
  props: {
    show: {
      required: true,
      type: Boolean,
      default: true,
    },
  },
  components: {
    WelcomeHome,
    WelcomeStep,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const store = vm.$store;
    const isPersonal = computed<boolean>(() => store.getters.editionFlag === 'personal');
    const inStep = ref<boolean>(false);
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    // 默认不显示
    const dialogVisible = ref<boolean>(false);
    // 新手引导流程（普通成员）
    const { workbenchSteps } = sidebarGuideHandler();
    const currentUser = computed(() => store.getters.userBaseInfo);
    const currentIsSuperAdmin = computed(() => currentUser.value.role === 'superAdmin');
    const isUser = computed(() => currentUser.value.role === 'user');
    const showCloseBtn = ref(false);
    const methods = {
      // 开始step表单
      startStepForm() {
        // 开启step过程,由于步骤条没有上一步，所以进入步骤条后，不能再返回到欢迎页了。
        inStep.value = true;
        const { step } = vm.$refs as any;
        // 设置了inStep之后，等待step组件加载后，再处理
        nextTick(() => step?.init());
      },
      /**
       * @param needHelp
       * true-开启探索
       * false-跳过
       */
      async goNext(needHelp: boolean) {
        needHelp &&
          reporter.report('manager_new_guide_success', {
            success_count_type: 'welcome_popup_agree',
          });
        // 更新后台数据，认为不再是新用户。
        smh.userAPI.createNoviceGuidance(store.getters.noviceGuidance);
        // 企业版 + 超级管理员 + 需要教学 + 留咨
        if (needHelp && currentIsSuperAdmin.value && !isPersonal.value) {
          // 新增私有化逻辑保持原来一致
          if (vm.$store.getters.isPrivate) {
            methods.startStepForm();
          } else {
            innerShow.value = false;
            ipc.emit(ipc.RENDERER_EVENTS_MAP.START_USER_SURVEY, true);
          }
          return;
        }
        innerShow.value = false;
        nextTick(() => {
          // 若是管理员角色，则需要执行管理员角色专属的弹窗控制
          if (needHelp) {
            ipc.emit(ipc.RENDERER_EVENTS_MAP.START_GUIDE);
            startGuideSteps(workbenchSteps.value);
          } else {
            ipc.emit(ipc.RENDERER_EVENTS_MAP.STOP_GUIDE);
            ipc.emit(ipc.RENDERER_EVENTS_MAP.SHOW_GUIDE_POPUP);
          }
        });
        reporter.report('newhand', {
          newhand_welcome: needHelp ? 'click' : 'ignore',
        });
      },
    };
    watch(innerShow, val => {
      if (val) {
        const { userRole } = user.getUserInfo();
        if (userRole === RoleMap.SuperAdmin) {
          reporter.report('manager_new_guide', {
            welcome_pop_up: 'show',
          });
        } else if (userRole === RoleMap.Admin) {
          reporter.report('boss_new_guide', {
            welcome_pop_up: 'show',
          });
        } else {
          reporter.report('staff_new_guide', {
            welcome_pop_up: 'show',
          });
        }
        reporter.report('newhand', {
          newhand_welcome: 'show',
        });
      }
    });
    return {
      innerShow,
      currentIsSuperAdmin,
      isUser,
      inStep,
      dialogVisible,
      isPersonal,
      showCloseBtn,
      ...methods,
    };
  },
});
